import { useState, useEffect, useCallback } from 'react';
import { generateClient } from 'aws-amplify/api';
import { LIST_ENTITIES } from '../lib/graphql/queries';

const client = generateClient();

interface CuroRecord {
  Id: string;
  LogicalName: string;
  Attributes: { Key: string; Value: any }[];
}

export function useEntities(entityName: string, filter?: Record<string, any>) {
  const [records, setRecords] = useState<CuroRecord[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEntities = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await client.graphql({
        query: LIST_ENTITIES,
        variables: {
          entityName,
          filter: filter ? JSON.stringify(filter) : undefined,
        },
      });
      const response = (result as any).data.listEntities;
      const parsed = typeof response === 'string' ? JSON.parse(response) : response;
      setRecords(parsed.data ?? []);
    } catch (err: any) {
      setError(err.message);
      setRecords([]);
    } finally {
      setIsLoading(false);
    }
  }, [entityName, JSON.stringify(filter)]);

  useEffect(() => {
    fetchEntities();
  }, [fetchEntities]);

  return { records, isLoading, error, refetch: fetchEntities };
}
